import { Badge } from 'reactstrap'
import { firstLetter } from 'common'
import React from 'react'

const UserActivityBadge = (props) => {
  const [activities, setActivities] = React.useState(props.activities)
  const [prio, setPrio] = React.useState(props.prio)
  const [n, setN] = React.useState(
    props.activities ? props.activities?.length : 0
  )
  const [showAll, setShowAll] = React.useState(false)
  const ref = React.useRef()

  React.useEffect(() => {
    if (prio && props.activities) {
      activities.map((a) => console.log(a.parent))
      activities.sort((a, b) => (a.parent == prio ? -1 : 1))
      setActivities([...activities])
    }
  }, [prio, props.activities])

  React.useEffect(() => {
    setPrio(prio)
  }, [prio])

  const isEllipsisActive = (e) =>
    e.offsetHeight < e.scrollHeight || e.offsetWidth < e.scrollWidth

  React.useEffect(() => {
    if (ref.current && isEllipsisActive(ref.current)) {
      setN(n - 1)
    }
  }, [ref.current, n])

  const hasEllipsis = n != activities?.length

  if (!activities) return ''
  if (showAll) {
    return (
      <div>
        {activities?.map((activity, i) => (
          <Badge
            key={activity.name}
            color='secondary-light'
            style={i == activities.length - 1 ? {} : { marginRight: '5px' }}
          >
            {firstLetter(activity.name)}
          </Badge>
        ))}
      </div>
    )
  }
  return (
    <div
      style={{
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
      }}
      ref={ref}
    >
      <div>
        {activities.slice(0, n).map((activity, i) => (
          <Badge
            key={activity.name}
            color='secondary-light'
            style={i == n - 1 && !hasEllipsis ? {} : { marginRight: '5px' }}
          >
            {firstLetter(activity.name)}
          </Badge>
        ))}
        {hasEllipsis && (
          <Badge
            color='light'
            onClick={() => setShowAll(true)}
            style={{ cursor: 'pointer', position: 'relative', zIndex: 31 }}
            key='ellipsis'
          >
            {`+${activities.length - n}`}
          </Badge>
        )}
      </div>
    </div>
  )
}

export default UserActivityBadge
